<!--
    描述：用户组人员列表
    时间：2020-04-26
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-tabs overflow-hidden">
					<span><b>人员列表</b></span>
				</div>
				<div class="btnGroups ml10">
					<el-button v-if="clickType =='virtualDeptClick' && roleBtns.includes('user_add')"
							   type="primary"
							   size="small"
							   @click="doClick('add')">保存
					</el-button>
				</div>
			</div>
			<div class="w-page-container">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content"
						 ref="usersContent">
						<el-table ref="groupUsersTable"
								  v-loading="groupUsersData.loading"
								  :data="groupUsersData.tableData"
								  :border="true"
								  :height="groupUsersData.tableH"
								  highlight-current-row>
							<el-table-column v-if="clickType =='virtualDeptClick'"
											 type="selection"
											 width="55"></el-table-column>
							<el-table-column prop="sname"
											 align="center"
											 label="人员姓名"
											 show-overflow-tooltip
											 min-width="120"></el-table-column>
							<el-table-column prop="username"
											 align="center"
											 label="用户名"
											 show-overflow-tooltip
											 min-width="120"></el-table-column>
							<el-table-column prop="deptName"
											 align="center"
											 label="部门"
											 show-overflow-tooltip
											 min-width="150"></el-table-column>
							<el-table-column label="操作"
											 align="center"
											 width="70"
											 show-overflow-tooltip>
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
                                               v-if="roleBtns.includes('user_delete')"
											   @click="doClick('delete',scope.row)"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer text-center">
						<el-pagination @size-change="handleSizeChange"
									   @current-change="handleCurrentChange"
									   :current-page="groupUsersData.currentPage"
									   :page-sizes="groupUsersData.pageList"
									   :page-size="groupUsersData.pageSize"
									   layout="total, sizes, prev, pager, next, jumper"
									   :total="groupUsersData.total"></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getGroupUsers } from '@/api/modules/user.js'
import { saveUserStations, deleteGroupUser } from '@/api/modules/group.js'

export default {
	data() {
		return {
			groupUsersData: {
				loading: false,
				tableH: 400,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			clickType: 'groupsClick',
			searchParam: {}
		}
	},
	methods: {
		getGroupUsers(row, clickType) {
			this.clickType = clickType
			this.searchParam = row
			let param = {}
			if (clickType === 'groupsClick') {
				param.groupId = row.id
			} else {
				param.groupId = row.groupId
				param.virtualGroupId = row.id
			}
			param.groupType = clickType
			param.current = this.groupUsersData.currentPage
			param.size = this.groupUsersData.pageSize
			getGroupUsers(param).then(res => {
				this.groupUsersData.tableData = res.data.records
				this.groupUsersData.total = parseInt(res.data.total)
				setTimeout(() => {
					this.groupUsersData.tableData
						.filter(f => f.isChecked === true)
						.forEach(v =>
							this.$refs.groupUsersTable.toggleRowSelection(
								v,
								true
							)
						)
				}, 10)
			})
		},

		//操作按钮事件
		doClick(type, row) {
			if (type === 'delete') {
				this.$confirm('确认从当前用户组移除该人员?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.deleteGroupUser(row)
				})
			} else {
				let array = this.$refs.groupUsersTable.selection
				if (!array.length > 0) {
					this.$message.warning('请勾选人员！')
				} else {
					let stationArray = []
					array.forEach(v =>
						stationArray.push({
							stationId: this.searchParam.id,
							userId: v.id
						})
					)
					this.doSave(stationArray)
				}
			}
		},

		//保存关联关系
		doSave(stationArray) {
			saveUserStations(stationArray).then(res => {
				res.code === 0
					? this.$message.success('保存成功！')
					: this.$message.error(res.msg)
			})
		},

		//移除用户组人员
		deleteGroupUser(row) {
			let param = {}
			param.groupId =
				this.clickType === 'groupsClick'
					? this.searchParam.id
					: this.searchParam.groupId
			param.stationId =
				this.clickType === 'virtualDeptClick' ? this.searchParam.id : ''
			param.userId = row.id
			deleteGroupUser(param).then(res => {
				res.code === 0
					? this.$message.success('移除人员成功！')
					: this.$message.error(res.msg)
				this.getGroupUsers(this.searchParam, this.clickType)
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.groupUsersData.pageSize = val
			this.getGroupUsers(this.searchParam, this.clickType)
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.groupUsersData.currentPage = cur
			this.getGroupUsers(this.searchParam, this.clickType)
		}
	},

	created() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.groupUsersData.tableData
					.filter(f => f.isChecked === true)
					.forEach(v =>
						this.$refs.groupUsersTable.toggleRowSelection(v, true)
					)
			}, 100)
		})
	},

	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.groupUsersData.tableH = this.$refs.usersContent.offsetHeight
			}, 100)
		})
	},

	// 进入缓存页面
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.groupUsersData.tableH = this.$refs.usersContent.offsetHeight
			}, 100)
		})
	},

	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},

	watch: {
		clientSize(val) {
			this.groupUsersData.tableH = this.$refs.usersContent.offsetHeight
		}
	}
}
</script>
<style lang="less"></style>
